<div class="back-arrow" *ngIf="(progress$ | async) < 100">
  <a class="back-arrow__link" (click)="navBack()">
    <app-icon [name]="backIconName" size="32"></app-icon>
  </a>
</div>
